import { get } from '../../api';
import { useGlobalStore } from '../state/globalStore';
import { ENTITY_TYPE } from '../utils/constants';
import { getEntityCookiePassword, getLeadCaptureUrl, responseTransformer } from '../utils/helper';
import { reportErrorToPlayer } from '../utils/player-controller';
import { ERROR_CODES } from '../utils/player-controller/constants';
import { Enum, LeadCapture } from '../utils/types';

const getEntityLeadCaptureData = async (
  entityType: Enum<typeof ENTITY_TYPE>,
  entityId: string,
  select: string[],
  leadId?: string,
) => {
  try {
    const entityPassword = getEntityCookiePassword(entityId, entityType);
    const url = getLeadCaptureUrl(entityPassword, leadId || '', select);
    const data = await get(url);

    let finalResponse = {} as LeadCapture;
    // Run the values through transformer
    for (const [key, value] of Object.entries(data as any)) {
      (finalResponse as any)[key] = responseTransformer(key, value, {
        resolveTags: true,
      });
    }
    return finalResponse;
  } catch (error) {
    reportErrorToPlayer({
      code: ERROR_CODES.LEAD_CAPTURE_FORM_DATA_FETCHING_FAILED,
      message: 'Error fetching lead capture form data',
    });
    return false;
  }
};

/**
 * After login/registration, we need to re-fetch the confirmation page data with resolved dynamic tags
 */
export const useRefreshConfirmationPage = () => {
  const entityId = useGlobalStore((store) => store.apiEntityId);
  const entityType = useGlobalStore((store) => store.entityType);
  const getLeadCaptureData = async (leadId: string) => {
    try {
      const select = ['confirmation_page_title', 'confirmation_page_description'];
      if (entityType) {
        let response = await getEntityLeadCaptureData(entityType, entityId, select, leadId);
        if (response) {
          useGlobalStore.setState({
            leadCapture: {
              ...useGlobalStore.getState().leadCapture,
              confirmationPageDescription: response.confirmationPageDescription,
              confirmationPageTitle: response.confirmationPageTitle,
            },
          });
        }
        return response;
      }
    } catch (error) {
      return false;
    }
  };
  return {
    refresh: getLeadCaptureData,
  };
};
